import { PERFORMANCE } from '../../../Core.constants';

export const getPerformanceLabel = (value) => Object.entries(PERFORMANCE).find(([, val]) => val === value)?.[0];
